<template>
	<div class="surroundImage">
		<el-card class="imgCard">
			<div id="jsv-holder">
				<img id="jsv-image" alt="your 360 images" :src="src" />
			</div>

			<div id="app"></div>
			<div class="log">
				<span id="log"></span>
				<span id="error-log"></span>
			</div>

		</el-card>
	</div>
</template>

<script>
	import {Decrypt,Encrypt} from '@/common/secret.js'
	import {
		JavascriptViewer
	} from "@3dweb/360javascriptviewer";
	// import { log } from "../../../utilities.ts";
	export default {
		data() {
			return {
				currentPicture: '',
				hotId: 225,
				imgDate:''
			}
		},
		computed: {
			src() {
				// var url = "https://cloud-exhibition-data.vjoevr.com/picture360/" + this.hotId + '/01'
				var url = "https://cloud-exhibition-data.vjoevr.com/picture360/" + this.imgDate + '/01'
				return url
			}
		},
		mounted() {
			console.log(document.body.clientWidth)
			console.log(document.body.clientHeight)
			let jsv = null
			this.hotId = this.$route.query.hotId
			let path = ''
			if(!this.$global.SERVER_OFFLINE) {
				path = 'api/cloudget/getTimestamp'
			}else {
				path = this.$global.SERVER_SUBFILE +'json/getTimestamp' + this.$route.query.hotId + '.json'
			}
			
			let params = {
				params:{
					hotId :this.hotId
				}
			}
			this.$global.axios
				.get(path,params)
				.then(res => {
					if(res.data.success) {
						console.log(res)
						this.imgDate = res.data.data
						jsv= new JavascriptViewer({
							// imageUrlFormat: "20180906-0xx-blauw.jpg",
							imageUrlFormat: `https://cloud-exhibition-data.vjoevr.com/picture360/${this.imgDate}/xx`,
							totalFrames: 36,
							reverse: true,
							autoRotate: 1
						});
						jsv
							.start()
							.then((started) => {
								// log(started ? "viewer started" : "viewer not started");
							})
							.catch((msg) => {
								// log(msg, true);
							});
					}else {
						console.log(res.data.msg)
					}
				})
			console.log(this.hotId)
			

			

		},
		methods: {

		}
	}
</script>

<style scoped="scoped">
	.surroundImage {
		margin: 30px auto;
	}
	@media all and (min-width: 750px){
		.surroundImage {
			width: 950px;
			height: 850px;
			/* width: 200px;
			height: 200px; */
		}
		#jsv-holder {
			width: 750px;
			height: 750px
		}
		#jsv-holder >>> img{
			width: 100%;
			height: 100%;
		}
	}
	@media all and (max-width: 750px) {
		.surroundImage {
			width: 100%;
			height: 100%;
			/* width: 200px;
			height: 200px; */
		}
		#jsv-holder {
			width: 100%;
			height: 100%
		}
		#jsv-holder >>> img{
			width: 100%;
			height: 100%
		}
	}
/* 	#jsv-holder >>> img{
		width: 500px;
		height: 500px;
	} */
/* 	#jsv-image {
		width: 300px;
		height: 300px;
	} */
	.imgCard {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
